import { Autocomplete, Grid, InputLabel, TextField, Tooltip } from '@mui/material';
import React from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import { machineList, speciesOptions, yesNoOption } from '../Data/HFDropDowdData';
import DetailedM3Table from './DetailedM3Table';
import UploadFiles from './UploadFiles';
import { EmployeeNameField } from 'routes/Pages/GenTask/components/SharedFormFields';
const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};
const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': {
        fontSize: '0.82rem',
        fontWeight: 500,
      },
    },
  },
};
const HFCompletedForestForm = ({
  completdForestData,
  setCompletedForestData,
  spList,
  spListObj,
  productionData,
  setProductionData,
  files,
  setNewUploadedFiles,
  handleDeleteFile,
  viewFile,
  machineList,
}) => {
  const combinedMachineOptions = React.useMemo(() => {
    const all = machineList.flatMap(group => group.values);
    return Array.from(new Set(all)); // dedupe
  }, [machineList]);

  const handleChangeData = (name, value) => {
    let updatedData = {
      [name]: value,
    };

    setCompletedForestData(prevData => ({
      ...prevData,
      ...updatedData,
    }));
  };

  const handleDashboardPictureChange = event => {
    const file = event.target.files;
    setNewUploadedFiles(file);
  };
  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
        paddingBottom: '1rem',
      }}>
      <EmployeeNameField value={completdForestData['employeeName']} onChange={handleChangeData} isOperator={true} />
      <InputFields
        label="Date & Time"
        helperText={'Enter Clock in Date & Time'}
        name="date_Time"
        required={true}
        value={completdForestData['date_Time']}
        textFieldType={'datetime-local'}
        width={4}
        handleIpChange={handleChangeData}
      />
      <Grid item xs={6} sm={6} md={4}>
        <Tooltip title=" Was their tops left to one side for the forwarder?">
          <InputLabel size="small" sx={dropDownStyles} required>
            Was their tops left to one side for the forwarder?
          </InputLabel>
        </Tooltip>

        <Autocomplete
          size="small"
          disablePortal
          name={'wasTheirTopsLeftToOneSideForTheForwarder'}
          value={completdForestData['wasTheirTopsLeftToOneSideForTheForwarder'] || null}
          options={yesNoOption}
          onChange={(event, newValue) => handleChangeData('wasTheirTopsLeftToOneSideForTheForwarder', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>

      {completdForestData['wasTheirTopsLeftToOneSideForTheForwarder'] === 'No' && (
        <InputFields
          label="State Why?"
          name="wasTheirTopsLeftToOneSideForTheForwarderReason"
          required={completdForestData['wasTheirTopsLeftToOneSideForTheForwarder'] == 'No'}
          value={completdForestData['wasTheirTopsLeftToOneSideForTheForwarderReason']}
          textFieldType={'text'}
          multiline={true}
          width={12}
          handleIpChange={handleChangeData}
        />
      )}

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Machine
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'machine'}
          value={completdForestData['machine'] || null}
          options={combinedMachineOptions}
          onChange={(event, newValue) => handleChangeData('machine', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>

      <Grid item xs={6} sm={6} md={6}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Forest or SP Number
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'forestSPNumber'}
          value={completdForestData['forestSPNumber'] || null}
          options={spListObj ? Object.keys(spListObj) : []}
          onChange={(event, newValue) => handleChangeData('forestSPNumber', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>
      <Grid item xs={6} sm={6} md={6}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Species
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'species'}
          value={completdForestData['species'] || null}
          options={speciesOptions}
          onChange={(event, newValue) => handleChangeData('species', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <DetailedM3Table
          productionData={productionData}
          setProductionData={setProductionData}
          currDailyHarvestingData={completdForestData}
          handleChangeDailyHarvestingData={handleChangeData}
        />
      </Grid>

      <InputFields
        label="Total M3 /Hr"
        name="total_M3PerHr"
        required={true}
        value={completdForestData['total_M3PerHr']}
        textFieldType={'number'}
        multiline={true}
        width={4}
        handleIpChange={handleChangeData}
      />

      <UploadFiles
        files={files}
        label={'Machine Dashboard Picture'}
        handleFileUpload={handleDashboardPictureChange}
        handleDeleteFile={handleDeleteFile}
        viewFile={viewFile}
      />
    </Grid>
  );
};

export default HFCompletedForestForm;
